export default {
  multipleUpdateTitle: 'Multiple records update',
  title: 'Details',
  rules: {
    required: 'Field is required',
    atLeast: 'Field must be at least',
    less: 'Field must be less than',
    more: 'Pole musi mieć more than',
    characters: 'characters',
    emailMustBeValid: 'E-mail must be valid',
    passwordMustDiffer: 'New password must be different from the old password',
    passwordMustBeSame: "Password can't be different",
  },
  alerts: {
    updated: 'Updated',
    updateError: 'Error! Update unsuccessful',
    stored: 'Dodano',
    storeError: 'Error! Store unsuccessful',
  },
  buttons: {
    create: 'Create',
    modify: 'Modify',
    modifySelected: 'Modify selected records',
    close: 'Close',
  },
  files: {
    upload: 'Upload file',
    show: 'Show',
    download: 'Download',
  },
}
